import styled, { css } from 'styled-components'
import { Link } from '@chegg-wt/core/theme/sunkist/link'
import { adjust } from '@chegg-wt/core/theme/theme'

export const smallFrameLayout = ({ theme }) => theme.adLayoutBreakpoints[0]
export const mediumFrameLayout = ({ theme }) => theme.adLayoutBreakpoints[1]
export const largeFrameLayout = ({ theme }) => theme.adLayoutBreakpoints[2]

const smallFrameSize = ({ theme }) => theme.sideFrameSizes[0]
const mediumFrameSize = ({ theme }) => theme.sideFrameSizes[1]
const largeFrameSize = ({ theme }) => theme.sideFrameSizes[2]

export const PseudoFixedPlacements = styled.div``

export const SideFrame = styled.div`
  overflow: auto;
  &&& {
    flex: 1 1 auto;
  }
`

export const SideView = styled.div`
  background-color: white;
  box-shadow: -2px 0 4px 0 rgba(0, 0, 0, 0.15);
  z-index: 1000;

  @media (max-width: ${(props) => adjust(smallFrameLayout(props), -1)}) {
    display: none;
  }

  @media (min-width: ${smallFrameLayout}) {
    display: flex;
    flex-direction: column;

    & > * {
      flex: 0 0 auto;
    }
  }
`

export const MainFrame = styled.div``

export const MainView = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;

  & > * {
    flex: 0 0 auto;
  }

  & > ${MainFrame} {
    flex: 1 1 auto;
    overflow: auto;
  }
`

export const BottomTray = styled.div<{ showSvp: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: fixed;
  bottom: 0px;
  z-index: 999;
  width: ${(props) =>
    props.showSvp ? `calc(100% - ${props.theme.sideFrameSizes[2]})` : '100%'};

  @media (max-width: ${(props) => adjust(smallFrameLayout(props), -1)}) {
    width: 100%;
  }

  @media (min-width: ${smallFrameLayout}) and (max-width: ${(props) =>
      adjust(mediumFrameLayout(props), -1)}) {
    width: ${(props) =>
      props.showSvp ? `calc(100% - ${props.theme.sideFrameSizes[0]})` : '100%'};
  }

  @media (min-width: ${mediumFrameLayout}) and (max-width: ${(props) =>
      adjust(largeFrameLayout(props), -1)}) {
    width: ${(props) =>
      props.showSvp ? `calc(100% - ${props.theme.sideFrameSizes[1]})` : '100%'};
  }
`

export const HideB1Wrapper = styled.div<{ showSvp: boolean }>`
  ${({ showSvp }) =>
    showSvp &&
    css`
      @media (max-width: ${(props) => adjust(mediumFrameLayout(props), -1)}) {
        display: none;
      }
    `}
`

export const CheckboxMenu = styled.div`
  width: 100%;
`

export const Viewports = styled.div<{ removeStyles: boolean }>`
  ${({ removeStyles }) =>
    !removeStyles &&
    css`
  position: fixed;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;

  @media (max-width: ${(props) => adjust(smallFrameLayout(props), -1)}) {
    display: flex;
    flex-direction: column;

    & > ${MainView} {
      flex: 1 1 320px;
      height: 100%;
    }

    & > ${SideView} {
      flex: 0 0 auto;
      height: 100%;
    }
  }

  @media (min-width: ${smallFrameLayout}) and (max-width: ${(props) =>
      adjust(mediumFrameLayout(props), -1)}) {
    display: flex;
    flex-direction: row;

    & > ${MainView} {
      flex: 1 1 320px;
      height: 100%;
    }

    & > ${SideView} {
      flex: 0 0 ${smallFrameSize};
      height: 100%;
    }
  }

  @media (min-width: ${mediumFrameLayout}) and (max-width: ${(props) =>
      adjust(largeFrameLayout(props), -1)}) {
    display: flex;
    flex-direction: row;

    & > ${MainView} {
      flex: 1 1 320px;
      height: 100%;
    }

    & > ${SideView} {
      flex: 0 0 ${mediumFrameSize};
      height: 100%;
    }
  }

  @media (min-width: ${largeFrameLayout}) {
    display: flex;
    flex-direction: row;

    & > ${MainView} {
      flex: 1 1 320px;
      height: 100%;
    }

    & > ${SideView} {
      flex: 0 0 ${largeFrameSize};
      height: 100%;
    }
  `}
`

/**
 * [1]: Visual adjustment to balance out space
 */
export const ScrollBelowAction = styled.a`
  ${Link};
  display: block;
  text-align: center;
  margin-bottom: 10px; /* [1] */
`

/**
 * [1]: Show first one on tablet, hide it on desktop, vice-versa for second one
 * [2]: I hate this code, but it's a quick a dirty solution that I need right now
 */
export const LiftedContainer = styled.div<{ shouldBeDisplayed?: boolean }>`
  ${({ shouldBeDisplayed = true }) =>
    shouldBeDisplayed
      ? ''
      : css`
          display: none;
        `};

  @media (min-width: ${mediumFrameLayout}) {
    padding-top: 10px;
  }

  @media (max-width: ${(props) => adjust(mediumFrameLayout(props), -1)}) {
    /* [1], [2] */
    & > ${ScrollBelowAction}:nth-of-type(2) {
      display: none;
    }
  }

  @media (min-width: ${mediumFrameLayout}) {
    /* [1], [2] */
    & > ${ScrollBelowAction}:nth-of-type(1) {
      display: none;
    }
  }
`

export const R2R3Wrapper = styled.div`
  display: flex;
  justify-content: space-around;

  @media (max-width: ${(props) => adjust(mediumFrameLayout(props), -1)}) {
    flex-direction: column;

    /* [1], [2] */
    & > ${ScrollBelowAction}:nth-of-type(2) {
      display: none;
    }
  }

  @media (min-width: ${mediumFrameLayout}) and (max-width: ${(props) =>
      adjust(largeFrameLayout(props), -1)}) {
    flex-direction: column;

    /* [1], [2] */
    & > ${ScrollBelowAction}:nth-of-type(1) {
      display: none;
    }
  }

  @media (min-width: ${largeFrameLayout}) {
    flex-direction: row-reverse;
    flex-wrap: wrap-reverse;

    & > ${ScrollBelowAction}:nth-of-type(1) {
      padding-top: 56px;
      padding-bottom: 10px;
    }

    /* [1], [2] */
    & > ${ScrollBelowAction}:nth-of-type(2) {
      display: none;
    }
  }
`
